export default "__VITE_ASSET__85f5eb0f__"